import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  onClick: () => void;
}

export const RetrievalQueriesButton: React.FC<IProps> = ({ onClick }) => {
  // No need for translations as this is a tool only for internal Faire users
  return (
    <ButtonWrapper>
      <Button variant="secondary" onClick={onClick}>
        Download Queries
      </Button>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled(Row).attrs({ justify: "center" })`
  width: 100%;
  padding: 5px;
  background-color: white;
`;
